$(function() {
  let $productQtyInput = $('.product-info .qty-input__input'),
      $cartQtyInput = $('.cart-item .qty-input__input');

  $productQtyInput.on('change', function () {
    let append = $(this).parents('.product-info').find('.price__default'),
        price = $(this).parents('.product-info').find('.price__current'),
        priceObject = $(this).parents('.product-info').find('.ymq-b2b-qb-table-box');
        
    priceDiscount(this, price, priceObject, append);
  });

  $cartQtyInput.on('change', function () {
    let append = $(this).parents('.cart-item').find('.cart-item__info'),
        price = $(this).parents('.cart-item').find('.price__current'),
        priceObject = $(this).parents('.cart-item').find('.ymq-b2b-qb-table-box');
        
    priceDiscount(this, price, priceObject, append);
  });

  function priceDiscount(input, price, priceObject, append) {
      $(priceObject).find('.ymq-b2b-table-tr').each(function (i, el) {
        let minimum = i == 0 ? $(this).attr('ymq-b2b-table-min') : 0;
        
        if (parseInt($(input).val()) >= parseInt($(this).attr('ymq-b2b-table-min')) && parseInt($(input).val()) <= parseInt($(this).attr('ymq-b2b-table-max'))) {
          $(append).addClass('active');
          $(append).attr('customDiscount', $(this).find('.ymq-b2b-price-span').text());
          // if (!$(append).find('.customDiscount')) {
          //   $('<strong class="customDiscount">'+ $(el).find('.ymq-b2b-price-span').text() +'</strong>').appendTo(append);
          // } else {
          //   $(append).find('.customDiscount').text($(el).find('.ymq-b2b-price-span').text())
          // }
          return false;
        } else if (parseInt($(input).val()) >= parseInt($(this).attr('ymq-b2b-table-min')) && $(this).attr('ymq-b2b-table-max') == '') {
          $(append).addClass('active');
          $(append).attr('customDiscount', $(this).find('.ymq-b2b-price-span').text());
          return false;
        } else if (parseInt($(input).val()) < parseInt(minimum)) {
          $(append).removeClass('active');
          $(append).removeAttr('customDiscount');
        }
      });
  }
});